import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
	selector: 'app-confirm-dialog',
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent implements OnInit {

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: {message: string, title?: string, confirmLabel?: string, denyLabel?: string},
	) { }

	ngOnInit() {
	}

}
